// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.MuiAppBar-colorDefault .xsifter-header {
    background-color: beige !important;
    --AppBar-background: beige !important;
}

.xsifter-appbar {
    padding: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/common/XSifterAppHeader.css"],"names":[],"mappings":";AACA;IACI,kCAAkC;IAClC,qCAAqC;AACzC;;AAEA;IACI,YAAY;AAChB","sourcesContent":["\r\n.MuiAppBar-colorDefault .xsifter-header {\r\n    background-color: beige !important;\r\n    --AppBar-background: beige !important;\r\n}\r\n\r\n.xsifter-appbar {\r\n    padding: 8px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
